import React from 'react';
import resume from '../../assets/personal/resume.png';

function Main({ onSearch, className }) {
  return (
    <div className={className}>
      <section className="content">
        <img
          className="logo"
          alt="Resume"
          src={resume}
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      </section>
    </div>
  );
}

export default Main;
